import { useEffect } from 'react';
import SubMenuBox from './sub-menu-box';
import { MenuItem, SelectedMenuItem } from '../../types';
import { DEFAULT_SELECTED_MENU_ITEM } from '../constants';
interface MenuGroupingProps {
  selectedItemId?: string;
  onSelect: (item: SelectedMenuItem) => void;
  items: MenuItem[];
}
function MenuGrouping({
  selectedItemId,
  onSelect,
  items
}: MenuGroupingProps) {
  useEffect(() => {
    return () => {
      onSelect(DEFAULT_SELECTED_MENU_ITEM);
    };
  }, [onSelect]);
  return <div className='hide-scrollbar relative min-h-0 min-w-[104px] shrink-0 overflow-y-auto pb-12 lg:pb-0 [&>div:first-child>a]:border-t-0 [&>div:first-child>button]:border-t-0' data-sentry-component="MenuGrouping" data-sentry-source-file="menu-grouping.tsx">
            {items.map((item, index) => {
      if (item.hideOnMobile) return null;
      const isSelected = item.id === selectedItemId;
      const hasItemAbove = index > 0;
      const prevItem = items[index - 1];
      const nextItem = items[index + 1];
      const hasItemBelow = index < items.length - 1;
      const roundTopLeft = hasItemAbove && (prevItem.id === selectedItemId || isSelected);
      const roundBottomLeft = hasItemBelow && (nextItem.id === selectedItemId || isSelected);
      const showBottomBorder = hasItemBelow && nextItem.id === selectedItemId;
      return <SubMenuBox {...item} key={item.id} isSelected={isSelected} roundTopLeft={roundTopLeft} roundBottomLeft={roundBottomLeft} showBottomBorder={showBottomBorder} subMenuChildren={item.children} onSelect={() => onSelect({
        id: item.id,
        title: item.title,
        href: item.href || '',
        subMenuChildren: item.children
      })} />;
    })}
        </div>;
}
export default MenuGrouping;